'use client';
import { useEffect } from 'react';
import { api } from './api';

/**
 * Подставляет брендовый цвет организации в токен `--brand` на время сессии
 * (white-label). Дефолт системы — LOGIXA-оранжевый из tokens.css; сюда
 * попадает только явно заданный организацией цвет.
 *
 * Внимание: перекрашивается ТОЛЬКО действие (кнопки, активный пункт).
 * Семантика — success/warning/danger/info — не трогается никогда, иначе
 * «доставлено» у одного клиента станет фиолетовым.
 *
 * Монтируется один раз в /dashboard/layout.tsx после гейта авторизации.
 */
export function useOrgBrand(orgId: string | null | undefined) {
  useEffect(() => {
    if (!orgId) return;
    // Don't override personal pref
    if (typeof window !== 'undefined' && localStorage.getItem('logixa_accent_personal')) return;

    api.get('/organizations/me')
      .then((org: any) => {
        if (org?.brandColor && /^#[0-9a-f]{3,8}$/i.test(org.brandColor)) {
          document.documentElement.style.setProperty('--brand', org.brandColor);
          document.documentElement.style.setProperty('--brand-hover', org.brandColor);
        }
      })
      .catch(() => {});
  }, [orgId]);
}
